// TODO ZL-856: replace this custom infrastructure with Firebase Remote Config
import * as z from 'zod'

export enum FeatureFlag {
  AppleSignIn = 'apple_sign_in',
  BetaSurvey = 'beta_survey',
  PromoCodes = 'promo_codes',
  YearPickerTabs = 'year_picker_tabs',
}

export type FeatureMap = Partial<Record<FeatureFlag, boolean>>

/**
 * Accepts keys this build has never heard of.
 *
 * A closed enum here was a release trap: every installed app version parses the
 * same `feature_flags` documents, so toggling a NEW flag made the whole document
 * fail to parse on every older build. All three readers use `retry: false`, so
 * the query kept no data and `useIsFeatureFlagEnabled` then read *every* flag as
 * off — turning one flag on would have switched Quests off for anyone who had
 * not upgraded.
 *
 * Unknown keys are kept rather than stripped, so a document that round-trips
 * through an older build does not lose the flags it could not name.
 *
 * The parsed type stays a partial record of the known flags: an unknown key is
 * data to preserve, not something this build can ask about.
 */
const featureMapSchema = z
  .record(z.string(), z.boolean())
  .transform((features): FeatureMap => features)

export const featureFlagsSchema = z.object({
  features: featureMapSchema.default({}),
})

export type FeatureFlags = z.infer<typeof featureFlagsSchema>
